import { type FC, type PropsWithChildren } from 'react';

import { styled } from '@eneco/sparky/stitches';

export const CHAMPION_ACTION_UNAVAILABLE_MESSAGE =
  'You are on a champion account so this action is unavailable';

const DisabledWrapper = styled('span', {
  display: 'inline-block',
  cursor: 'not-allowed',
  opacity: 0.5,

  '& > *': {
    pointerEvents: 'none',
  },
});

export const ChampionDisabledAction: FC<PropsWithChildren> = ({ children }) => (
  <DisabledWrapper title={CHAMPION_ACTION_UNAVAILABLE_MESSAGE}>{children}</DisabledWrapper>
);
